import { useState, useEffect } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { FieldConfig } from "../../formConfig";

function formatCurrency(raw: string): string {
  const digits = raw.replace(/[^\d]/g, "");
  if (!digits) return "";
  const cents = digits.padStart(3, "0");
  const whole = cents.slice(0, -2).replace(/^0+(?=\d)/, "");
  const decimal = cents.slice(-2);
  const formatted = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return `${formatted || "0"}.${decimal}`;
}

function toStorageValue(display: string): string {
  const digits = display.replace(/[^\d]/g, "");
  if (!digits) return "";
  const cents = digits.padStart(3, "0");
  const whole = cents.slice(0, -2).replace(/^0+(?=\d)/, "") || "0";
  const decimal = cents.slice(-2);
  return `${whole}.${decimal}`;
}

export default function CurrencyField({ field }: { field: FieldConfig }) {
  const { setValue, register } = useFormContext();
  const stored = useWatch({ name: field.id }) as string;
  const [display, setDisplay] = useState(() => formatCurrency((stored ?? "").replace(".", "")));

  useEffect(() => {
    register(field.id);
  }, [register, field.id]);

  useEffect(() => {
    const expected = formatCurrency((stored ?? "").replace(".", ""));
    if (expected !== display) setDisplay(expected);
  }, [stored]);

  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    const raw = e.target.value.replace(/[^\d]/g, "");
    const formatted = formatCurrency(raw);
    setDisplay(formatted);
    const storageVal = toStorageValue(raw);
    setValue(field.id, storageVal, { shouldDirty: true, shouldTouch: true });
  }

  return (
    <div className="currency-input-wrap">
      <span className="currency-prefix">$</span>
      <input
        id={field.id}
        type="text"
        inputMode="numeric"
        autoComplete="nope"
        data-form-type="other"
        data-lpignore="true"
        data-1p-ignore
        value={display}
        onChange={handleChange}
        placeholder="0.00"
      />
    </div>
  );
}
